"use client";

import React, { useEffect, useRef } from 'react'
import Image from "next/image";
import Link from "next/link";
import Head from "next/head";
// import WordPressFooter from "@/app/components/WordPressFooter"

const Footer = () => {
  const footerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const loadFooter = async () => {
      const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/footer`, {
        method: "GET",
        headers: {
          "Content-Type": "text/html",
          "Authorization": `Bearer ${process.env.NEXT_PUBLIC_API_SECRET_TOKEN}`, // if token is required
        },
        cache: 'no-store',
      });
      const html = await response.text();

      if (footerRef.current) {
        const shadowRoot = footerRef.current.attachShadow({ mode: 'open' });

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Import <style>, <link>, and <footer> into Shadow DOM
        const headElements = doc.head.querySelectorAll('link, style');
        const bodyContent = doc.body.innerHTML;

        // Inject styles
        headElements.forEach(el => {
          shadowRoot.appendChild(el.cloneNode(true));
        });

        // Inject HTML
        const wrapper = document.createElement('div');
        wrapper.innerHTML = bodyContent;
        shadowRoot.appendChild(wrapper);

        const style = document.createElement('style');
        style.textContent = `
  .ts-contain.wrap {
    max-width: 1070px;
    margin: 0 auto;
  }
`;
        shadowRoot.appendChild(style);
      }
    };

    loadFooter();
  }, []);


  return (
    <>
      <Head>
        <link
          rel="preload"
          as="image"
          href="https://res.cloudinary.com/dvqccxtdm/image/upload/q_auto/v1747648962/logo_c1fpuc.webp"
          imageSrcSet="
          https://res.cloudinary.com/dvqccxtdm/image/upload/q_auto,w_100/v1747648962/logo_c1fpuc.webp 100w,
          https://res.cloudinary.com/dvqccxtdm/image/upload/q_auto,w_150/v1747648962/logo_c1fpuc.webp 150w,
          https://res.cloudinary.com/dvqccxtdm/image/upload/q_auto,w_200/v1747648962/logo_c1fpuc.webp 200w
        "
          imageSizes="(max-width: 768px) 100px, 150px"
        />
      </Head>
      <div id="footer-container" ref={footerRef}></div>
      {/* <iframe
        src="https://uccricket.live/footer-only"
        width="100%"
        height="850"
        style={{
          border: 'none',
          overflowY: 'auto',
        }}
        scrolling="yes"
      /> */}
    </>
  )
}

export default Footer